

<!--<template>
  <div class="soon-item">
    <div class="soon-item__outer">
      <div class="soon-item__name">{{ soon.name }}</div>
      <div class="soon-item__description">{{ $t(soon.description) }}</div>
      <div class="soon-item__soon">{{ $t("soon_soon") }}</div>
      <div class="soon-item__image">
        <img src="@/assets/images/soon-app.png" alt="" />
      </div>
    </div>
  </div>
</template>-->

<script>
import { mapGetters } from "vuex";

export default {
  name: "soon-item",

  props: {
    soon: {
      type: Object,
      default: null,
    },
  },

  data: () => ({}),

  computed: {},

  methods: {},
};
</script>
